import type { AxiosResponse } from 'axios';

import {
  MakeResponse,
  ModelResponse,
  ISearch,
  ISearchResponse,
  RetrieveSuggestedSectionResponse,
} from 'api/types/searchApiTypes';
import { donedealGateway } from 'api/api-utils/commonApiUtils';

async function getAllMakes(): Promise<AxiosResponse<MakeResponse>> {
  const response: AxiosResponse<MakeResponse> = await donedealGateway.get(
    `/ddapi/legacy/search/api/v3/sections/filters/search/cars`,
  );
  return response;
}

async function getAllModels(
  make: string,
): Promise<AxiosResponse<ModelResponse>> {
  const response: AxiosResponse<ModelResponse> = await donedealGateway.get(
    `/ddapi/legacy/search/api/v3/sections/filters/search/cars/make/${make}/values`,
  );
  return response;
}

async function getMotorCount(
  payload: ISearch,
): Promise<AxiosResponse<ISearchResponse>> {
  const response: AxiosResponse<ISearchResponse> = await donedealGateway.post(
    `/ddapi/legacy/search/api/v4/find/`,
    payload,
  );
  return response;
}

async function getSuggestedSections(
  item: string,
): Promise<AxiosResponse<RetrieveSuggestedSectionResponse[]>> {
  const response: AxiosResponse<RetrieveSuggestedSectionResponse[]> =
    await donedealGateway.get(`/ddapi/legacy/search/suggested/${item}`);
  return response;
}

export const searchApi = {
  getAllMakes,
  getAllModels,
  getMotorCount,
  getSuggestedSections,
};
